import React from 'react';
import { useTranslation } from 'react-i18next';
import { StarFilled } from '@ant-design/icons';

const TESTIMONIAL_DATA = [
  { name: 'Sarah J.', roleKey: 'home.t1_role', textKey: 'home.t1_text', rating: 5 },
  { name: 'Michael T.', roleKey: 'home.t2_role', textKey: 'home.t2_text', rating: 5 },
  { name: 'David R.', roleKey: 'home.t3_role', textKey: 'home.t3_text', rating: 4 },
];

const Testimonials: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="hp-section bg-white">
      <div className="hp-container">
        <div className="hp-section-header">
          <h2>{t('home.testimonials_title')}</h2>
          <p>{t('home.testimonials_subtitle')}</p>
        </div>
        <div className="row g-4">
          {TESTIMONIAL_DATA.map((item, index) => (
            <div key={index} className="col-md-4">
              <div className="card h-100 border-0 shadow-sm p-4">
                <div className="mb-3 text-warning">
                  {[...Array(item.rating)].map((_, i) => (
                    <StarFilled key={i} />
                  ))}
                </div>
                <p className="mb-4 text-muted">"{t(item.textKey)}"</p>
                <div className="mt-auto">
                    <h5 className="mb-0 fw-bold">{item.name}</h5>
                    <small className="text-muted">{t(item.roleKey)}</small>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
